<template>
    <v-container class="pa-4 text-center">
        <v-row wrap>
          <v-col cols="12" sm="12" md="6" lg="4" v-for="team in teams" :key="team.name"> 
            <v-card class="text-center ma-2 rounded-xl" style="border-bottom: 5px solid #082543">
              <v-responsive class="pt-4">
                 <v-avatar size="200" class="grey lighten-2 my-4">
                   <img :src="team.avatar">
                 </v-avatar>
              </v-responsive>
              <v-card-text>
                <div class="headline white--text " v-text="team.name"/>
                <div class="grey--text body-1 mt-3" v-text="team.role"/>
              </v-card-text>
              <v-card-actions class="justify-center">
               <div v-for="(social, k, ind) in team.socials" v-bind:key="ind" class="mb-3 mt-4"  >
                      <v-btn  :href="social.link" target="_blank"  icon class="mx-2" >
                        <v-icon  size="35" v-text="social.icon"/>
                      </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    data(){
        return{
            teams: [
        {name: 'BENOTMANE Mohammed', role: 'Full Stack Web Developer', avatar: '/team3.jpg', socials: [
          {icon:'facebook', link:'https://www.facebook.com/mohamed.benotmane.9'}, 
          {icon: 'mdi-linkedin', link:'https://www.linkedin.com/in/mohammed-benotmane/' },
          {icon: 'mdi-github', link:'https://github.com/Mohammed-Benotmane'}, 
          
      ] },
        {name: 'BONNOR Oussama', role: 'Frontend/Mobile Developer', avatar: '/team1.jfif', socials: [
          {icon:'facebook', link:'https://www.facebook.com/oussama.bonnor.1'}, 
          {icon: 'mdi-linkedin', link:'https://www.linkedin.com/in/oussama-bonnor/' },
          {icon: 'mdi-github', link:'https://github.com/oussamabonnor1'}, 
          
      ]},
        {name: 'BOUHRIZ Abir', role: 'Front-end Web Developer', avatar: '/team2.png', socials: [
          {icon:'facebook', link:'https://www.facebook.com/amiraprincesse.amira/'}, 
          {icon: 'mdi-linkedin', link:'https://www.linkedin.com/in/abir-bouhriz-daidj-504aab1a8/' },
          {icon: 'mdi-github', link:'https://github.com/Abir-Bouhriz'}, 
          
      ]},
      ],
        }
    }
}
</script>
<style>

</style>